module.exports = __webpack_public_path__ + "img/fzi.fc18a8a4.png";